import React, { useState } from 'react';
import { Button } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import VersionHistoryMenu from '@/components/buttons/VersionHistoryMenu';
import { useWorkspaceContext } from '@/context/WorkspaceContext';

export const VersionHistoryButton = () => {
	const { isBusy, handleSaved } = useWorkspaceContext();
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<Button
				variant='outlined'
				startIcon={<HistoryIcon />}
				onClick={(event) => setAnchorEl(event.currentTarget)}
				disabled={isBusy}
			>
				Version history
			</Button>
			<VersionHistoryMenu
				anchorEl={anchorEl}
				onClose={handleClose}
				onRestore={handleSaved}
			/>
		</>
	);
};

export default VersionHistoryButton;
VersionHistoryButton.displayName = 'VersionHistoryButton';
